import React, { useState, useEffect} from "react";
import { Banner } from "./../../_components";
import { useParams } from 'react-router';
import { Header, BalanceCodeForm, Balance } from "./_sections";
import {getSettings} from "../../_utils";
import {
  decodeBase64
} from "../../../_utils";

export default function GiftCardBalance() {

  const [code, setCode] = useState('');
  const [monthUpdatedAt, setMonthUpdatedAt] = useState('');
  const [initialValue, setInitialValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [translations, setTranslations] = useState({});
  const [settings, setSettings] = useState({});
  const [giftCard, setGiftCard] = useState(null);

  /**
   * takes in a card number, fetches card info and updates state
   */
  useEffect(() => {
    getSettings()
    .then(res => {
      setTranslations(res.translations);
      setSettings(res);
      setLoading(false);
    })
    .catch(err => {
      console.log(err);
    });
  }, []);

  /**
   * Lookup the gift card data based on the search input
   */
  const getGiftCard = (e, query) => {

    setBalanceLoading(true);
    e.preventDefault()

    const formData = new FormData();

    formData.append("code", code);
    formData.append("initialValue", initialValue);
    formData.append("monthUpdatedAt", monthUpdatedAt);

    const config = {
      method: 'POST',
      body: formData
    };

    fetch(`${window.Shopify?.routes?.root}a/gc/api/giftcard/balance/`, config)
    .then(response => response.json())
    .then((response) => {
      setGiftCard(response);
      setBalanceLoading(false);
      setInitialValue('');
      setMonthUpdatedAt('');
    })
    .catch((err) => {
      setGiftCard(null);
      setBalanceLoading(false);
      setInitialValue('');
      setMonthUpdatedAt('');
    })
    ;

  };

  const styleVars = loading ? {} : {
    "--gc__var-brand_color": settings.global.appearance.brand_color,
    "--gc__var-accent_color": settings.global.appearance.accent_color,
    "--gc__var-button_text_color": settings.global.appearance.button_text_color,
  };

  return loading === false ? (
    <div className ={"gc__page_wrapper page-width site-wrapper wrapper main-content container"} id="gcpBalancePage" style = { styleVars } >
      <div className="gc__content-top" dangerouslySetInnerHTML={{__html: decodeBase64(settings.global.appearance.balance_page_content_top) }}></div>
      <div className="gc__single-column gc__shadow-box">
        <div className="gc__shadow-box">
          <div className="gc__grid-item">
            <div className="gc__flex-column">
              <Header
                giftCard={giftCard}
                title={translations.purchase.check_balance_title}
              />
              {giftCard && (giftCard.status === "error") && <Banner
                status="error"
              >
                {giftCard.message}
              </Banner>}
              <Balance
                settings={settings}
                giftCard={giftCard}
              />
            </div>
          </div>
          <BalanceCodeForm
            code={code}
            setCode={setCode}
            initialValue={initialValue}
            setInitialValue={setInitialValue}
            monthUpdatedAt={monthUpdatedAt}
            setMonthUpdatedAt={setMonthUpdatedAt}
            giftCard={giftCard}
            getGiftCard={getGiftCard}
            translations={translations}
            loading={balanceLoading}
          />
        </div>
      </div>
      <div dangerouslySetInnerHTML={{__html: decodeBase64(settings.global.appearance.balance_page_content_bottom) }}></div>
    </div>
  ) :
    <></>
};
